import styles from './FeaturesButtons.module.scss';
import Button from '../../../../../ui/Button/Button';
import React from 'react';

export default function FeaturesButtons({ slide, comingSoonText }) {
  return (
    <div className={styles.buttons} data-aos="fade-up">
      {(slide?.buttons || []).map((button, index) => {
        return button.isComingSoon ? (
          <button key={index} className={styles.comingSoon}>
            {comingSoonText || 'Coming soon'}
          </button>
        ) : (
          <Button
            key={index}
            className={styles.button}
            variant={index === 1 ? 'secondary' : 'primary'}
            isShowTooltip={!button?.path}
            target={button?.path || '#'}
          >
            {button.label}
          </Button>
        );
      })}
    </div>
  );
}
